export default __webpack_public_path__ + "static/media/facebook.d6c81a68.svg";